module.exports = global["autosize"] = require("-!.\\textarea-autosize.js");